<template>
    <transition name="fade" mode="out-in">
        <div
            v-if="!loading"
            class="history w-100"
            :class="{ 'd-none': loading }"
        >
            <div
                class="history__body"
                v-if="
                    dataHistory &&
                        dataHistory.rows &&
                        dataHistory.rows.length > 0
                "
            >
                <h1 class="history__title">LỊCH SỬ CƯỢC</h1>
                <div class="history__box-filter">
                    <div class="history__box-date">
                        <div class="history__box-filter-date">
                            <div class="history__box-filter-date--wrap">
                                <label for="fromDate">Từ Ngày</label>
                                <InputDatepicker
                                    :config="fromDatepickerConfig"
                                    id="fromDate"
                                    v-model="today"
                                    :name="'fromDatepicker'"
                                    @onChange="updateFromDay"
                                />
                            </div>
                        </div>
                        <div class="history__box-filter-date history__box-filter-from-date">
                            <div class="history__box-filter-date--wrap">
                                <label for="toDate">Đến ngày</label>
                                <InputDatepicker
                                    :config="toDatepickerConfig"
                                    id="toDate"
                                    v-model="nextDay"
                                    :name="'toDatepicker'"
                                    @onChange="updateNextDay"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="history__box-filter-button">
                        <Button
                            value="Xem"
                            @click="clickViewHistory"
                            theme="dark"
                            variant="secondary"
                            class="button-filter-custom"
                        />
                    </div>
                    <p v-if="isMobile" class="history__sub-title">
                        KẾT QUẢ CƯỢC TỪ {{ todayDisplay.toUpperCase() }} ĐẾN
                        {{ nextDayDisplay.toUpperCase() }}
                    </p>
                    <div class="history__box-date result-display">
                        <div v-if="isMobile" class="history__box-filter-date">
                            <label for="display">Hiển thị</label>
                            <Select
                                @change="changeDisplay"
                                :value="valueDisplay"
                                :options="numberDisplay"
                                id="display"
                                class="history__select-display"
                            />
                        </div>
                        <div
                            v-if="isMobile"
                            class="history__box-filter-date history__box-filter-from-date"
                        >
                            <label for="resultDisplay">Kết quả</label>
                            <Select
                                @change="changeFilterDisplay"
                                :value="valueFilter"
                                :options="optionFilter"
                                id="resultDisplay"
                                class="history__number-display"
                            />
                        </div>
                    </div>
                </div>
                <template v-if="historyBets && historyBets.length > 0">
                    <div
                        class="d-flex align-items-center justify-content-between mb-3"
                    >
                        <p v-if="!isMobile" class="mb-0">
                            KẾT QUẢ CƯỢC TỪ {{ todayDisplay.toUpperCase() }} ĐẾN
                            {{ nextDayDisplay.toUpperCase() }}
                        </p>
                        <div v-if="!isMobile" class="history__box-filter-date">
                            <label for="display">Hiển thị</label>
                            <Select
                                @change="changeDisplay"
                                :value="valueDisplay"
                                :options="numberDisplay"
                                class="history__select-display"
                            />
                        </div>
                    </div>

                    <transition name="fade" mode="out-in" v-if="!isMobile">
                        <div
                            class="history__paginate-loading"
                            v-if="changingPage || loadingHistory"
                        >
                            <Spinner :classes="['history__paginate-spinner']" />
                        </div>
                        <HistoryTablePC
                            @change-page="changePage"
                            @play-again="playAgain"
                            :historyBets="historyBets"
                            :optionFilter="optionFilter"
                            :valueFilter="valueFilter"
                            :pageCount="
                                dataHistory.attrs
                                    ? dataHistory.attrs.last_page
                                    : 1
                            "
                            :currentPage="
                                dataHistory.attrs
                                    ? dataHistory.attrs.current_page
                                    : 1
                            "
                            v-else
                        />
                    </transition>
                    <div class="history__content-mobile" v-else>
                        <transition name="fade" mode="out-in">
                            <Spinner v-if="loadingHistory" />
                            <div v-else>
                                <HistoryRowTableMB
                                    @play-again="playAgain"
                                    :historyBets="filterHistoryBet"
                                />
                                <transition name="fade" mode="out-in">
                                    <Spinner
                                        v-if="loadingMore"
                                        :classes="['history__load-more']"
                                    />
                                    <template v-else>
                                        <div
                                            v-on:click="
                                                loadMoreInfo(
                                                    dataHistory.attrs
                                                        .current_page,
                                                )
                                            "
                                            v-if="canLoadMore"
                                            class="history__view-more"
                                        >
                                            <span>Xem thêm</span>
                                        </div>
                                    </template>
                                </transition>
                            </div>
                        </transition>
                    </div>
                </template>
                <template v-else>
                    <div class="history__notification-not-bet">
                        <p>
                            Quý khách không đặt cược trong khoảng thời gian này!
                        </p>
                        <span class="icon__not-bet icon__not-bet-filter"></span>
                        <router-link :to="{ name: 'home' }">
                            <Button
                                value="Xem Lô Đề Hôm Nay"
                                theme="dark"
                                variant="secondary"
                                class="button-filter-custom"
                            />
                        </router-link>
                    </div>
                </template>
            </div>
            <div
                class="history__notification-not-bet"
                v-else-if="dataHistory && dataHistory.rows"
            >
                <p>Quý khách chưa đặt cược!</p>
                <span class="icon__not-bet"></span>
                <router-link :to="{ name: 'home' }">
                    <Button
                        value="Xem Lô Đề Hôm Nay"
                        theme="dark"
                        variant="secondary"
                        class="button-filter-custom"
                    />
                </router-link>
            </div>
            <div class="history__notification-not-bet" v-else>
                <p>Server hiện đang quá tải!</p>
                <span class="icon__not-bet"></span>
                <router-link :to="{ name: 'home' }">
                    <Button
                        value="Xem Lô Đề Hôm Nay"
                        theme="dark"
                        variant="secondary"
                        class="button-filter-custom"
                    />
                </router-link>
            </div>
        </div>
        <Spinner v-else />
    </transition>
</template>

<script>
import HistoryTablePC from '@/components/common/HistoryTablePC/HistoryTablePC';
import InputDatepicker from '@/components/common/InputDatepicker/InputDatepicker';
import Select from '@/components/common/Select/Select';
import Button from '@/components/common/Button/Button';
import HistoryRowTableMB from '@/components/common/HistoryRowTableMB/HistoryRowTableMB';
import historyService from '@common/services/history.service';
import resultService from '@common/services/result.service';
import Spinner from '@/components/common/Spinner/Spinner';
import { mapActions, mapGetters } from 'vuex';
const moment = require('moment');

const Status = {
    WIN: 1,
    LOST: 2,
    WAITING: 0,
};

const Region = {
    BAC: 'north',
    TRUNG: 'central',
    NAM: 'south',
};

export default {
    components: {
        Spinner,
        HistoryTablePC,
        InputDatepicker,
        Select,
        Button,
        HistoryRowTableMB,
    },
    data() {
        return {
            historyBets: [],
            dataHistory: {},
            currentPage: 1,
            canLoadMore: false,
            isClickLoadMore: false,
            today: null,
            nextDay: null,
            todayDisplay: null,
            nextDayDisplay: null,
            Status: Status,
            Region: Region,
            valueDisplay: { name: '10', value: '10' },
            numberDisplay: [
                { name: '10', value: '10' },
                { name: '20', value: '20' },
                { name: '30', value: '30' },
            ],
            valueFilter: { name: 'Tất cả', value: -1 },
            optionFilter: [
                { name: 'Tất cả', value: -1 },
                { name: 'Đã thua', value: Status.LOST },
                { name: 'Đã thắng', value: Status.WIN },
                { name: 'Đang chờ', value: Status.WAITING },
            ],
            result: null,
            fromDatepickerConfig: {
                dateFormat: 'd-m-Y',
            },
            toDatepickerConfig: {
                dateFormat: 'd-m-Y',
            },
            loading: true,
            isMobile: false,
            loadingMore: false,
            changingPage: false,
            loadingHistory: false,
        };
    },
    methods: {
        ...mapActions({
            fetchStartDate: 'userModule/fetchStartDate',
        }),

        async changePage(e) {
            this.changingPage = true;
            await this.initDataPC(
                this.today,
                this.nextDay,
                this.valueDisplay.value,
                e,
            );
            this.changingPage = false;
        },

        async getDataHistory(dateFrom, dateTo, limit, page) {
            return await historyService.getHistoryData(
                this.token,
                dateFrom,
                dateTo,
                limit,
                page,
            );
        },

        async loadMoreInfo(currentPage) {
            this.isClickLoadMore = true;
            this.loadingMore = true;
            const limit = this.valueDisplay.value;
            if (this.canLoadMore) {
                await this.initDataMobile(
                    this.today,
                    this.nextDay,
                    limit,
                    currentPage + 1,
                );
            }
            this.loadingMore = false;
        },

        async initDataMobile(dateFrom, dateTo, limit, page) {
            try {
                const result = await this.getDataHistory(
                    dateFrom,
                    dateTo,
                    limit,
                    page,
                );
                if (result.data) {
                    if (this.isClickLoadMore) {
                        this.dataHistory = {
                            ...this.dataHistory,
                            attrs: result.data.attrs,
                        };
                        this.historyBets = [
                            ...this.historyBets,
                            ...result.data.rows,
                        ];
                    } else {
                        this.dataHistory = result.data;
                        this.historyBets = result.data.rows;
                    }
                    this.canLoadMore = !!(
                        this.dataHistory &&
                        this.dataHistory.attrs &&
                        this.dataHistory.attrs.current_page <
                            this.dataHistory.attrs.last_page
                    );
                }
            } catch (e) {
                console.log(e);
            }
        },

        async initDataPC(dateFrom, dateTo, limit, page) {
            try {
                const result = await this.getDataHistory(
                    dateFrom,
                    dateTo,
                    limit,
                    page,
                );
                console.log(result)
                if (result.data) {
                    this.dataHistory = result.data;
                    this.historyBets = this.dataHistory.rows;
                    this.canLoadMore = !!(
                        this.dataHistory &&
                        this.dataHistory.attrs &&
                        this.dataHistory.attrs.current_page <
                            this.dataHistory.attrs.last_page
                    );
                }
            } catch (e) {
                console.log(e);
            }
        },

        async clickViewHistory(isDisplayNumber = false) {
            this.loadingHistory = true;
            if (isDisplayNumber) {
                this.today = this.todayDisplay;
                this.nextDay = this.nextDayDisplay;
                console.log(isDisplayNumber);
            } else {
                this.todayDisplay = this.today;
                this.nextDayDisplay = this.nextDay;
            }

            if (this.isMobile) {
                this.isClickLoadMore = false;
                await this.initDataMobile(
                    this.today,
                    this.nextDay,
                    this.valueDisplay.value,
                    1,
                );
            } else {
                await this.initDataPC(
                    this.today,
                    this.nextDay,
                    this.valueDisplay.value,
                    1,
                );
            }
            this.loadingHistory = false;
        },

        playAgain(data) {
            let index = -1;
            if (this.result.length > 0) {
                const dataRegion = this.result.find(v => {
                    return v.name === data.city.region;
                });
                if (dataRegion.data.length > 0) {
                    index = dataRegion.data.findIndex(v => {
                        return v.id === data.city.id;
                    });
                }
            }
            if (index > -1) {
                delete data.date;
                this.$router
                    .push({
                        name: this.Region[data.city.region.toUpperCase()],
                        params: { reBet: data },
                    })
                    .catch(() => {});
            } else {
                this.$swal.fire({
                    title:
                        '<div class="popup__icon popup__icon--limit-number"></div>',
                    html:
                        `<b>Hôm nay không có đài ${data.city.name} <br>` +
                        'Bạn vui lòng chọn đài khác.</b>',
                    customClass: {
                        popup: 'swal2-popup-warning-custom',
                    },
                    showCloseButton: true,
                });
            }
        },

        changeDisplay(valueDisplay) {
            this.valueDisplay = valueDisplay;
            this.clickViewHistory(true);
        },

        changeFilterDisplay(valueFilter) {
            this.valueFilter = valueFilter;
        },

        updateFromDay({ dateStr }) {
            this.today = dateStr;
            this.toDatepickerConfig = this.setToDatepickerOptions();
        },

        updateNextDay({ dateStr }) {
            this.nextDay = dateStr;
            this.fromDatepickerConfig = this.setFromDatepickerOptions();
        },

        onResize() {
            this.isMobile = window.innerWidth < 992;
        },

        setFromDatepickerOptions() {
            const nextDate = new Date(moment(this.nextDay, 'DD-MM-YYYY'));
            return {
                dateFormat: 'd-m-Y',
                enable: [
                    function(date) {
                        return date < nextDate;
                    },
                ],
            };
        },

        setToDatepickerOptions() {
            const today = new Date(moment(this.today, 'DD-MM-YYYY'));
            return {
                dateFormat: 'd-m-Y',
                enable: [
                    function(date) {
                        return date >= today;
                    },
                ],
            };
        },
    },

    async created() {
        if (!this.token) {
            this.$router.push({ name: 'home' }).then();
        }

        this.loading = true;
        await this.fetchStartDate();
        this.today = this.currentDate;
        this.nextDay = moment(this.currentDate, 'DD-MM-YYYY')
            .add(1, 'days')
            .format('DD-MM-YYYY');
        this.todayDisplay = this.today;
        this.nextDayDisplay = this.nextDay;
        this.fromDatepickerConfig = this.setFromDatepickerOptions();
        this.toDatepickerConfig = this.setToDatepickerOptions();

        if (this.isMobile) {
            await this.initDataMobile(
                this.today,
                this.nextDay,
                this.valueDisplay.value,
                1,
            );
        } else {
            await this.initDataPC(
                this.today,
                this.nextDay,
                this.valueDisplay.value,
                1,
            );
        }
        const load = async () => {
            const getResultNorth = await resultService.getResultData(
                'bac',
                this.currentDate,
                {},
            );

            const getResultCentral = await resultService.getResultData(
                'trung',
                this.currentDate,
                {},
            );

            const getResultSouth = await resultService.getResultData(
                'nam',
                this.currentDate,
                {},
            );

            Promise.all([
                getResultNorth,
                getResultCentral,
                getResultSouth,
            ]).then(values => {
                const [resultNorth, resultCentral, resultSouth] = values;
                this.result = [
                    {
                        name: 'bac',
                        data: resultNorth.data.rows,
                    },
                    {
                        name: 'trung',
                        data: resultCentral.data.rows,
                    },
                    {
                        name: 'nam',
                        data: resultSouth.data.rows,
                    },
                ];
            });
        };
        load();
        this.loading = false;
    },

    computed: {
        ...mapGetters({
            currentDate: 'userModule/startDate',
            token: 'userModule/token',
        }),

        filterHistoryBet() {
            let data = this.historyBets;
            if (this.valueFilter.value !== -1) {
                data = this.historyBets.filter(v => {
                    return v.status === this.valueFilter.value;
                });
            }
            return data;
        },
    },
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, {
                passive: true,
            });
        }
    },
    mounted() {
        this.onResize();
        window.addEventListener('resize', this.onResize, { passive: true });
    },
};
</script>

<style scoped lang="scss">
@import 'History.scss';
</style>
